import { render, staticRenderFns } from "./ProductFavorite.vue?vue&type=template&id=398d5374"
import script from "./ProductFavorite.vue?vue&type=script&lang=js"
export * from "./ProductFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports